import { useController } from "react-hook-form";
import FormField, { useFormField } from "./FormField/FormField";
import { TimePicker, TimePickerProps } from "@mui/x-date-pickers/TimePicker";
import { UseFormFieldProps } from "./Form.types";

export interface FormTimePickerProps
  extends UseFormFieldProps, Omit<TimePickerProps<Date>, "label"> {}

export function FormTimePicker(props: FormTimePickerProps) {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <TimePicker {...field} {...childProps} value={field.value ?? null} />
    </FormField>
  );
}
